import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=a044ea5c&scoped=true&v-bind%3Avalue=value&v-on%3Ainput=%24emit('input'%2C%20%24event.target.value)"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044ea5c",
  null
  
)

export default component.exports